export const getDeviceCountryCode = () => {
  let userLocale =
    typeof navigator !== 'undefined'
      ? navigator.language ||
        // @ts-expect-error: TODO: describy why
        navigator.browserLanguage ||
        // @ts-expect-error: TODO: describy why
        navigator.userLanguage
      : '';

  if (userLocale.includes('_')) {
    userLocale = userLocale.replace('_', '-');
  }

  const countryCode = userLocale.split('-')[1];

  return countryCode ? countryCode.toLowerCase() : 'us';
};
